import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { PermissionService } from '@core/auth/services/permission.service'
import { ContentState, setupContentStateRouteListener } from '@core/utils/route-utils'
import { CertificateHolderManagerService } from '@features/certificate-holder/services/certificate-holder-manager.service'
import { CertificateHolderCtaButtonComponent } from '@features/certificate-holder/components/certificate-holder-cta-btn/certificate-holder-cta-btn.component'
import { CertificateHolderDisplayComponent } from '@features/certificate-holder/components/certificate-holder-display/certificate-holder-display.component'

@Component({
  selector: 'albert-certificate-holder',
  imports: [
    CertificateHolderCtaButtonComponent,
    CertificateHolderDisplayComponent
  ],
  templateUrl: './certificate-holder.component.html',
  styleUrl: './certificate-holder.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [CertificateHolderManagerService]
})
export class CertificateHolderComponent implements OnInit {
  public readonly manager = inject(CertificateHolderManagerService)
  public readonly contentState = signal<ContentState>('none')
  protected readonly router = inject(Router)
  protected readonly permissionService = inject(PermissionService)
  private readonly route = inject(ActivatedRoute)
  private readonly destroyRef = inject(DestroyRef)

  public ngOnInit(): void {
    setupContentStateRouteListener(this.route, this.destroyRef, this.manager.contentState, this.contentState)
  }
}
